/*
 *
 * OperationSecurityWarnings
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import './OperationSecurityWarnings.scss'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import formattedMessage from './languageModule'

const OperationSecurityWarnings = ({ warnings, isLoading }) => (
  <div className='text_field_section'>
    {isLoading ? (
      <PortalTextBlocked label=' ' value='' isLoading={isLoading} noPadding />
    ) : warnings?.length ? (
      warnings.map((field, index) => (
        <PortalTextBlocked
          key={`operation-security-warning-field-${index}`}
          label={field?.code || ''}
          value={field?.description || '-'}
          noPadding
        />
      ))
    ) : (
      <span className='text_field_section_empty_message'>{formattedMessage.emptyList}</span>
    )}
  </div>
)

OperationSecurityWarnings.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  warnings: PropTypes.array,
  isLoading: PropTypes.bool
}

OperationSecurityWarnings.defaultProps = {
  // Add here some default propTypes values
  warnings: [],
  isLoading: false
}

export default OperationSecurityWarnings
